import React, { useEffect, useRef } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useAuth, hasAuthParams } from 'react-oidc-context';

import BlankLayout from './BlankLayout';
import { Route as IRoute } from './models';
import { useDOPermissions } from '../auth';

export const PrivateRoute = (route: IRoute) => {
  const Layout = route.layout || BlankLayout;
  const auth = useAuth();
  const { hasDOScopes } = useDOPermissions();
  const tokenScopes = auth.user?.scopes ?? [];
  const hasTriedSignin = useRef(false);

  useEffect(() => {
    if (
      !hasAuthParams() &&
      !auth.isAuthenticated &&
      !auth.activeNavigator &&
      !auth.isLoading &&
      !hasTriedSignin.current
    ) {
      sessionStorage.setItem(
        'post-auth-redirect',
        window.location.pathname + window.location.search,
      );
      void auth.signinRedirect();
      hasTriedSignin.current = true;
    }
  }, [auth]);

  return (
    <Route
      path={route.path}
      exact={route.exact}
      render={props => {
        if (auth.isLoading || !auth.isAuthenticated) {
          return null;
        }
        if (!hasDOScopes) {
          return <Redirect to="/auth/unauthorized" />;
        }
        if (route.requiredScopes && route.requiredScopes.length > 0) {
          const hasMatch = route.requiredScopes.every(scope => tokenScopes.includes(scope));
          if (!hasMatch) {
            return <Redirect to="/digital-orders" />;
          }
        }
        if (route.redirectTo) {
          return <Redirect to={route.redirectTo} />;
        }
        return (
          <Layout {...props}>
            <route.component {...props} {...route} />
          </Layout>
        );
      }}
    />
  );
};
